module.exports = __webpack_public_path__ + "assets/53dd6d86e11845165f31515a2845dd24.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/denoms/denom-7.mp3
 ** module id = 474
 ** module chunks = 0
 **/